export function jsonToFormData(json: any, parentKey: string = '', keepNullKeys: boolean = false): FormData {
  const formData = new FormData();

  function appendFormData(data: any, parent: string) {
    if (data !== null && data !== undefined) {
      if (Array.isArray(data)) {
        data.forEach((value, index) => {
          const key = parent ? `${parent}[${index}]` : `${index}`;
          appendFormData(value, key);
        });
      } else if (typeof data === 'object' && !(data instanceof File)) {
        Object.keys(data).forEach((key) => {
          const fullKey = parent ? `${parent}[${key}]` : key;
          appendFormData(data[key], fullKey);
        });
      } else if (typeof data === 'boolean')
        formData.append(parent, data ? '1' : '0')
      else {
        formData.append(parent, data);
      }
    } else if (keepNullKeys && parent) {
      formData.append(parent, '');
    }
  }

  appendFormData(json, parentKey);
  return formData;
}